import { useEffect } from 'react';

const useAmoSocialButton = () => {
  const { KOMMO_SOCIAL_ID, KOMMO_SOCIAL_HASH } = window;

  useEffect(() => {
    if (!KOMMO_SOCIAL_ID || !KOMMO_SOCIAL_HASH) {
      return;
    }

    const script = document.createElement('script');
    script.text = `(function(a,m,o,c,r,m){a[m]={id:"${KOMMO_SOCIAL_ID}",hash:"${KOMMO_SOCIAL_HASH}",locale:"en",inline:false,setMeta:function(p){this.params=(this.params||[]).concat([p])}};a[o]=a[o]||function(){(a[o].q=a[o].q||[]).push(arguments)};var d=a.document,s=d.createElement('script');s.async=true;s.id=m+'_script';s.src='https://gso.kommo.com/js/button.js?1684743851';d.head&&d.head.appendChild(s)}(window,0,'crmPlugin',0,0,'crm_plugin'));`;
    document.head.appendChild(script);

    return () => script.remove();
  }, [KOMMO_SOCIAL_ID, KOMMO_SOCIAL_HASH]);
};

export default useAmoSocialButton;
